export default __webpack_public_path__ + "static/media/VerizonConnect_GlowWordmark_RGB.98bb10a9.svg";